(()=>{
  const mobile=window.matchMedia('(max-width:749px)');
  const path=location.pathname;
  try{
    const remember=()=>{if(path.includes('/collections/')||path.endsWith('/search'))sessionStorage.setItem('optcg-ux-browse',path+location.search);};
    remember();window.addEventListener('pagehide',remember);
    const previous=sessionStorage.getItem('optcg-ux-browse');
    if(previous&&/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/|search(?:\?|$))/i.test(previous))document.querySelectorAll('[data-ux-back]').forEach(a=>a.href=previous);
  }catch{}
  document.querySelectorAll('[data-ux-stock]').forEach(a=>{
    const u=new URL(location.href);u.searchParams.delete('page');
    if(a.dataset.uxStock==='1')u.searchParams.set('filter.v.availability','1');else u.searchParams.delete('filter.v.availability');
    a.href=u.pathname+u.search;
    if((a.dataset.uxStock==='1')===u.searchParams.has('filter.v.availability')&&new URL(location.href).searchParams.has('filter.v.availability')=== (a.dataset.uxStock==='1'))a.setAttribute('aria-current','true');
  });
  const toggle=document.querySelector('.ux-filter-toggle'),filters=document.getElementById('ux-singles-filters');
  if(toggle&&filters){
    const setFilters=open=>{filters.hidden=!open;toggle.setAttribute('aria-expanded',String(open));};
    const responsive=()=>{toggle.hidden=!mobile.matches;setFilters(!mobile.matches);};
    responsive();mobile.addEventListener('change',responsive);
    toggle.addEventListener('click',()=>setFilters(filters.hidden));
  }
  document.querySelectorAll('[data-ux-buy]').forEach(bar=>{
    const form=document.getElementById(bar.dataset.uxBuy);if(!form)return;
    const native=form.querySelector('[name=add]'),button=bar.querySelector('button');if(!native||!button)return;
    const section=form.closest('section'),price=section?.querySelector('[id^="price-"]');
    document.body.append(bar);
    let visible=true;
    const sync=()=>{button.disabled=native.disabled;button.textContent=native.querySelector('span')?.textContent.trim()||native.textContent.trim();bar.hidden=!mobile.matches||visible;const amount=price?.querySelector('.price--on-sale .price__sale .price-item--sale')||price?.querySelector('.price__regular .price-item--regular');if(amount)bar.querySelector('[data-ux-buy-price]').textContent=amount.textContent.trim();};
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();}).observe(native);
    new MutationObserver(sync).observe(native,{attributes:true,childList:true,subtree:true,characterData:true});
    if(price)new MutationObserver(sync).observe(price,{childList:true,subtree:true,characterData:true});
    mobile.addEventListener('change',sync);sync();
  });
})();
